import { motion } from 'motion/react';
import { Sparkles, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { mascot } from '../data/mock';

const InDevelopmentPage = () => {
    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 relative overflow-hidden select-none">
            <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="text-center max-w-lg z-10"
            >
                <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                    className="w-28 h-28 mx-auto mb-8 border border-slate-200 rounded-2xl p-2 bg-[#FAF9F6]"
                >
                    <img
                        src={mascot.main}
                        alt="Working Mascot"
                        className="w-full h-full object-contain"
                    />
                </motion.div>

                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                >
                    <div className="inline-flex items-center gap-2 bg-[#FAF9F6] border border-slate-200 px-4 py-1.5 rounded-full mb-6">
                        <Sparkles className="w-3.5 h-3.5 text-slate-800" />
                        <span className="text-[10px] font-black uppercase tracking-widest text-slate-800">Coming Soon</span>
                    </div>

                    <h1 className="text-3xl lg:text-4xl font-black text-slate-950 mb-4 tracking-tighter">
                        ¡Estamos cocinando algo grande!
                    </h1>

                    <p className="text-slate-500 text-sm mb-8 leading-relaxed font-semibold">
                        Nuestra App aún está en el horno 🍪. <br />
                        Estamos trabajando duro para traerte la mejor experiencia de viaje.
                    </p>

                    <Link to="/">
                        <Button
                            className="bg-slate-900 hover:bg-slate-800 text-white rounded-full px-8 py-5 text-xs font-black uppercase tracking-wider shadow-sm border-none transition-all duration-300"
                        >
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            Volver al inicio
                        </Button>
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default InDevelopmentPage;
